<template>
    <div id="data-list-list-view" class="data-list-container">
      <h1>{{ $t("letters") }}</h1>
      <br>
      <vx-card v-if="user_role === 'admin'" title="Exportation"  ref="filterCard"  class="user-list-filters mb-4"  >
      <div class="vx-row ">
        <div class="vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
            <p class="mb-2" > Entreprise </p>
            <v-select v-model="corporate_id" :options="corporates" :reduce="rep => rep.id" label="denomination" autocomplete >
            </v-select>
        </div>
        <div class="vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
          <p class="mb-2" > Date début </p>
          <datepicker
            v-model="date_debut"
            v-validate="'required'"
            name="birthDate"
            class="w-full"
          ></datepicker>
        </div>
        <div class="vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
          <p class="mb-2" > Date fin </p>
          <datepicker
            v-model="date_fin"
            v-validate="'required'"
            name="birthDate"
            class="w-full"
          ></datepicker>
        </div>
        <div class="vx-col w-full flex justify-end mt-4">
         <!--  <download-excel
            class="btn-add-new icon-chrome p-2  mr-2 ml-2 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            :fetch= "export_excel"
            work sheet="My Worksheet"
            name="Export_Excel_lettre.xls"
          >
            Exporter
          </download-excel> -->
        <vs-button @click="export_excel()" color="success" type="filled" icon-pack="feather" icon="icon-download">Exporter</vs-button>
     </div>
      </div>

    </vx-card>
    <br>
      <vx-card  ref="filterCard"  :title="$t('filtre')" class="user-list-filters mb-4 "  >
        <div class="vx-row">
          <div class="vx-col w-ful sm:w-full md:w-full lg:w-full xl:w-full">
            <p class="mb-2" > Entreprise </p>
            <v-select v-model="corporate" :options="corporates" :reduce="rep => rep.id" label="denomination" autocomplete >
            </v-select>
          </div>
         <!--  <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
            <p class="mb-2" > Succursale </p>
            <v-select v-model="branch" :options="branches" :reduce="rep => rep.id" label="name" autocomplete >
            </v-select>
          </div> -->
        </div>
      </vx-card>
      <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
      <vs-table ref="table"  :max-items="itemsPerPage" search :data="letters">
  
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
  
          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
            <!-- ADD NEW -->
            <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium  text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">{{ $t("Ajouter") }}</span>
            </div>
          </div>
  
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2"><b>{{ count }}</b></span>
            </div>
          </vs-dropdown>
           
        </div>
  
        <template slot="thead">
          <vs-th sort-key="number">{{ $t("number") }}</vs-th>
          <vs-th sort-key="code">{{ $t("code") }}</vs-th>
          <vs-th sort-key="Nom_Prenons">{{ $t("type_personne") }}</vs-th>
          <vs-th sort-key="Nom_Prenons">{{ $t("Nom_Prenons") }}</vs-th>
          <vs-th sort-key="healthFacility">{{ $t("healthFacility") }}</vs-th>
          <vs-th sort-key="acte">{{ $t("acteS") }}</vs-th>
          <vs-th sort-key=" ens_succ">{{ $t("ens_succ") }}</vs-th>
          <vs-th sort-key=" author">{{ $t("author") }}</vs-th>
          <vs-th sort-key="created_at">{{ $t("created_at") }}</vs-th>
          <!--<vs-th sort-key="updated_at">{{ $t("updated_at") }}</vs-th>-->  
          <vs-th>Action</vs-th>
        </template>
  
        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{tr.number}}</p>
            </vs-td>
             <vs-td>
              <p class="product-name font-medium truncate">{{tr.code}}</p>
            </vs-td>
            <vs-td>
                <p class="product-name font-medium truncate">{{ typeObject[tr.type] }}</p>
              </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{tr.fullName}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{tr.healthFacility !== null ? tr.healthFacility.name : '-'}}</p>
            </vs-td>
            <vs-td>
                <li v-for="(act, index) in tr.acts" :key="index" class="product-name font-medium truncate">
                  {{ act.act.name }}
                </li>
            </vs-td>
            
            <vs-td>
              <p v-if="tr.author.corporate" class="product-name font-medium truncate">
                {{ tr.author.corporate !== null ? tr.author.corporate.denomination : '-' }}
              </p>
              <p v-if="tr.author.branch" class="product-name font-medium truncate">
                {{ tr.author.branch !== null ? tr.author.branch.name : '-' }}
              </p>
              <p v-if="tr.author.branch === null && tr.author.corporate === null " class="product-name font-medium truncate">{{ '-'}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{tr.author !== null ? tr.author.username : '-'}}</p>
            </vs-td>
            <vs-td>
                  <p class="product-name font-medium truncate">{{tr.created_at | date_time}}</p>
            </vs-td>
            <!-- <vs-td>
              <p class="product-name font-medium truncate">{{tr.updated_at | date_time}}</p>
            </vs-td> -->
            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <vx-tooltip text="Imprimer" color="primary">
                    <feather-icon
                      style="color: rgb(0, 4, 255)"
                        icon="PrinterIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                        @click="cardLetter(tr.id,tr.number,tr.card.fullName)"
                      />
                  </vx-tooltip>
                <vx-tooltip :text="$t('Modifier')" color="warning">
                  <feather-icon
                    style="color: #FF9F43"
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-warning stroke-current"
                    class="mr-2"
                    @click="editData(tr)"
                  />
                </vx-tooltip>
                <vx-tooltip :text="$t('Supprimer')" color="danger">
                  <feather-icon
                    @click="deleteData(tr.id)"
                    style="color: red"
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <br>
      <div v-if="this.pageTotal>1" class="flex flex-wrap justify-between my-5" >
      <vs-button  :disabled="pageCount === 1"  v-if="this.repPrev !== null" @click="prev()" class="ml-4 mb-4">Précédent</vs-button>
<!--       <span class="my-5"><b>Page({{pageCount}})/Page({{countPages}})</b></span>
 -->      <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">Page({{ pageCount }}) / Page({{ countPages }})</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
              <vs-dropdown-menu  class="dropdown-scroll">
              <vs-dropdown-item
                v-for="n in countPages"
                :key="n"
                @click="paginationAll(n)"
              >
                <span>{{ n }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
      <vs-button  :disabled="pageCount === pageTotal"  v-if="this.repNext !== null" @click="next()" class="ml-4 mb-4" >Suivant</vs-button>
      </div>
    </div>
  </template>
<script>
  
import DataViewSidebar from './DataViewSidebarLetters.vue'
import Datepicker from 'vuejs-datepicker'

const str = 'https://form.grouptransvie.com/api/'
  
export default {
  components: {
    DataViewSidebar,
    Datepicker
  },
  data () {
    return {
      user_role:'',
      date_debut:'',
      date_fin: '',
      corporate_id:'',
      corporate_value: '',
      corporate: '',
      branch: '',
      branch_value: '',
      corporates: [],
      branches: [],
      typeObject: {
        member: 'Adhérent',
        beneficiary: 'Bénéficiaire'
      },
      pageTotal:1,
      pageCount:1,
      count: 0,
      repNext:'',
      repPrev: '',
      prevPage: '',
      nextPage: '',
      letters: [],
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  watch: {
    corporate (value) {
      if (value) {
        this.corporate_value = value
        const corporate = this.corporate_value
        this.$vs.loading()
        this.$http.get('paginated-letter-of-guaranties/', {
          params: { corporate }
        })
          .then((response) => {
            if (response.data.results.length !== 0) {
              this.count = 0
              this.pageCount = 1
              this.count = response.data.count
              this.letters = response.data.results
              this.repNext = str + (response.data.next).substr(34)
              this.repPrev = str + (response.data.previous).substr(34)
              this.$vs.loading.close()
            } else {
              this.count = 0
              this.letters = []
              this.$vs.loading.close()
            }
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else {
        this.corporate_value = ''
        this.getAllletters()
      }
    },
   
    /* branch (value) {
      if (value) {
        const corporate = this.corporate
        this.branch_value = value
        const branch = this.branch_value
        this.$vs.loading()
        this.$http.post('owner-filter-paginated/', { branch, corporate})
          .then((response) => {
            if (response.data.results.length !== 0) {
              this.count = 0
              this.pageCount = 1
              this.letters = response.data.results
              this.count = response.data.count
              this.nextPage = str + (response.data.next).substr(34)
              this.prevPage = str + (response.data.previous).substr(34)
              this.$vs.loading.close()
            } else {
              this.count = 0
              this.letters = []
              this.$vs.loading.close()
            }
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else {
        this.branch_up = ''
        this.getAllletters()
      }
    }, */
    count (newVal) {
      if (this.isMounted && newVal > 10) {
        this.pageTotal = Math.ceil(newVal / 10)
      } else {
        this.pageTotal = 1
      }
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    countPages () {
      if (this.isMounted && this.count > 10) {
        return Math.ceil(this.count / 10)
      }
      return 1
    },
    countPagesResulte () {
      if (this.count > 10) {
        return true
      }
      return false
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.letters.length
    }
  },
  methods: {
    async export_excel () {
      const corporate_id = this.corporate_id
      const date_debut = this.date_debut ? this.$store.state.convertDateTime(new Date(this.date_debut)).date : ''
      const date_fin = this.date_fin ? this.$store.state.convertDateTime(new Date(this.date_fin)).date : ''
      this.$vs.loading()
      try {
        const response = await this.$http.post('letters/export_excel/', { date_debut, date_fin, corporate_id }, { responseType: 'blob' })
        // Récupère le nom de fichier depuis l'entête si présent
        const disposition = response.headers['content-disposition'] || ''
        let filename = 'Export_Excel_lettre.xlsx'
        const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
        if (match) filename = match[1].replace(/['"]/g, '')
        const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      } catch (err) {
        this.$vs.notify({
          title: 'Error',
          text: err.message || 'Export failed',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    countNext () {
      if (this.pageTotal > this.pageCount) {
        if (this.pageCount <= this.count) { this.pageCount = this.pageCount + 1 }
      }
    },
    countPrev () {
      if (this.count > 10) {
        if (this.pageCount > 1) {
          this.pageCount = this.pageCount - 1
        }
      }
    },
    paginationAll_filter (npage) {
      this.$vs.loading()
      this.$http.post(`${str}paginated-letter-of-guaranties/?page=${npage}`, {
        phoneNumber:this.phoneNumber_up,
        branch:this.branch_up
      })
        .then((response) => {
          this.pageCount = npage
          this.count = 0
          this.letters = response.data.results
          this.count = response.data.count
          this.nextPage = str + (response.data.next).substr(34)
          this.prevPage = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    paginationAll (npage) {
      this.$vs.loading()
      this.$http.get(`${str}paginated-letter-of-guaranties/`, { params: {page: npage} })
        .then((response) => {
          this.pageCount = npage
          this.count = 0
          this.letters = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    next () {
      this.$vs.loading()
      this.$http.get(this.repNext)
        .then((response) => {
          this.countNext()
          this.count = 0
          this.letters = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    prev () {
      this.$vs.loading()
      this.$http.get(this.repPrev)
        .then((response) => {
          this.countPrev()
          this.count = 0
          this.letters = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
  
    deleteData (id) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: this.$t('enteteDelete'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.delete(`letters/${id}/`)
            .then(response => {
              this.getAllletters()
              window.getPrendTaCom.success(this.$t('Suppressionletter'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('Suppression') })
            })
        }
      })
  
    },
    cardLetter (id, code, name) {
      this.$http.get(`letters/${id}/print/`, { responseType: 'blob' })
        .then(({ data }) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const url = URL.createObjectURL(blob)
          const a = Object.assign(document.createElement('a'), {
            href: url,
            download: `LETTRE DE GARANTIE-${code}/${name}.pdf`
          })
          document.body.appendChild(a)
          a.click()
          URL.revokeObjectURL(url)
          a.remove()
        })
        .catch(err => this.$vs.notify({
          time: 8000,
          title: 'ATTENTION ERREUR DE TELECHARGEMENT',
          text: err,
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-x-circle',
          position: 'top-center'
        })
        )
    },

    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
  
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    
    getAllletters () {
      this.$vs.loading()
      this.$http.get('paginated-letter-of-guaranties/')
        .then((response) => {
          this.pageCount = 1
          this.letters = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = response.data.previous
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },

    getAllcorporates () {
      this.$vs.loading()
      this.$http.get('corporates/')
        .then((response) => {
          this.corporates = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
  
    getAllbranches () {
      this.$http.get('branches/')
        .then((response) => {
          this.branches = response.data
        })
        .catch(() => {
        })
    }
   
  },
  async created () {
    window.letters = this
    this.user_role = JSON.parse(localStorage.getItem('userInfo')).role
    this.$vs.loading()
    this.getAllletters()
    this.getAllcorporates()
    //this.getAllbranches()
    document.title = 'TransVie | PDV'

  },
  mounted () {
    this.isMounted = true
  }
}
</script>
  
  <style lang="scss">
    .dropdown-scroll {
      max-height: 200px; // ou une autre hauteur selon ton besoin
      overflow-y: auto;
      width: max-content; // optionnel pour s’adapter au contenu
    }
  #data-list-list-view {
    .vs-con-table {
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;
  
          .vs-table--search-input {
            width: 100%;
          }
        }
      }
  
      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }
  
      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;
  
          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }
  
      .product-name {
        max-width: 23rem;
      }
  
      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }
  
        .vs-table--search{
          padding-top: 0;
  
          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;
  
            &+i {
              left: 1rem;
            }
  
            &:focus+i {
              left: 1rem;
            }
          }
        }
      }
  
      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
  
        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }
  
      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;
  
          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }
  
      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
  </style>